"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgComponent(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 11.164, height: 16.125, viewBox: "0 0 11.164 16.125", color: "#e25050" }, props),
        React.createElement("path", { "data-name": "Icon ionic-ios-flame", d: "M4.19 0C5.314 5.217-.039 5.113 0 10.365c.031 4.3 4.589 5.76 5.6 5.76a5.916 5.916 0 005.547-5.76C11.425 6.241 7.981 2.302 4.19 0zm2.88 13.749a1.535 1.535 0 01-2.961 0 2.628 2.628 0 01-.093-.678A6.683 6.683 0 015.59 9.648a6.7 6.7 0 011.566 3.423 2.439 2.439 0 01-.086.678z", fill: "currentColor" })));
}
exports.default = SvgComponent;
//# sourceMappingURL=SvgFlame.js.map